<!-- Icon -->
<span class="ham-icon icon">
    <i class="exclamation-outline-icon"></i>
</span>

<!-- Text -->
<div class="banner-text">
    {{ message }}
</div>

<!-- ← Spacer takes all the remaining space → -->
<div class="flex-spacer"></div>

<!-- “Do not show again” button -->
<ham-button variant="glass" (buttonClick)="onDismiss()" size="xs"
    >{{ 'aumico_MM_sync_dismiss_text' | i18next }}
</ham-button>

<!-- “Request Additional Licenses” button -->
<ham-button variant="glass" data-testid="mm-sync" (buttonClick)="onSync()" outline="true" size="xs">{{
    'aumico_MM_sync_yes_text' | i18next
}}</ham-button>
